(function () {
    'use strict';
    angular.module('quantixApp').controller('RestrictiveAccessController', RestrictiveAccessController);

    RestrictiveAccessController.$inject = ['$scope', 'GenericServiceNew', 'CompanyReportService', '$http', '$window'];
    function RestrictiveAccessController($scope, GenericServiceNew, CompanyReportService, $http, $window) {

        $scope.section = false;
        $scope.message = '';
        $scope.clientModel = 'Select Client';
        $scope.restrictAcc = {
            "crisilAnalytics": {
                "parent": false,
                "irs": false,
                "companyScorecard": false,
                "fsm": false
            },
            "companyGroupOverview": {
                "parent": false,
                "mcaCharges": false
            },
            "companyFinancials": {
                "parent": false,
                "summary": false,
                "detailedAnnual": false,
                "detailedQuarterly": false
            },
            "ratings": {
                "parent": false,
                "outstandingRating": false,
                "instrumentRating": false,
                "ratingDrivers": false,
                "bankerDetails": false,
                "ratingHistory": false
            },
            "capitalMarketData": {
                "parent": false,
                "ytm": false,
                "debtIssuance": false,
                "cpIssuance": false,
                "keyStockIndicator": false,
                "bulkAndBlock": false
            },
            "crisilOutlook": {
                "parent": false,
                "industryOutlook": false,
                "economyOutlook": false
            },
            "peerBenchmarking": false,
            "alternateData": {
                "parent": false,
                "epfoContribution": false,
                "dueDiligence": false,
                "litigations": false
            }
        }

        $scope.restFilter = function() {
            $scope.clientModel = 'Select Client';
        }
        
        $scope.getClientNameList = function() {
			CompanyReportService.getClientNameList().then(function(data) {
				$scope.clientNameList = data;
			}, function(errordata) { });
        }
        
        $scope.changePrimaryPoints = function(sectionNumber) {
            switch (sectionNumber) {
                case 1:
                    $scope.restrictAcc.companyGroupOverview.parent = $scope.restrictAcc.companyGroupOverview.mcaCharges;
                    break;
                case 2:
                    $scope.restrictAcc.companyFinancials.parent = $scope.restrictAcc.companyFinancials.summary || $scope.restrictAcc.companyFinancials.detailedAnnual || $scope.restrictAcc.companyFinancials.detailedQuarterly;
                    break;
                case 3:
                    $scope.restrictAcc.ratings.parent = $scope.restrictAcc.ratings.outstandingRating || $scope.restrictAcc.ratings.instrumentRating || $scope.restrictAcc.ratings.ratingDrivers || $scope.restrictAcc.ratings.bankerDetails || $scope.restrictAcc.ratings.ratingHistory;
                    break;
                case 4:
                    $scope.restrictAcc.capitalMarketData.parent = $scope.restrictAcc.capitalMarketData.keyStockIndicator || $scope.restrictAcc.capitalMarketData.debtIssuance || $scope.restrictAcc.capitalMarketData.cpIssuance || $scope.restrictAcc.capitalMarketData.bulkAndBlock || $scope.restrictAcc.capitalMarketData.ytm;
                    break;
                case 6:
                    $scope.restrictAcc.crisilAnalytics.parent = $scope.restrictAcc.crisilAnalytics.fsm || $scope.restrictAcc.crisilAnalytics.irs || $scope.restrictAcc.crisilAnalytics.companyScorecard;
                    break;
                case 7:
                    $scope.restrictAcc.crisilOutlook.parent = $scope.restrictAcc.crisilOutlook.industryOutlook || $scope.restrictAcc.crisilOutlook.economyOutlook;
                    break;
                case 8:
                    $scope.restrictAcc.alternateData.parent = $scope.restrictAcc.alternateData.epfoContribution || $scope.restrictAcc.alternateData.dueDiligence || $scope.restrictAcc.alternateData.litigations;
                    break;
                default:
                    break;
            }
        }

        $scope.changeSecondaryPoints = function(sectionNumber) {
            switch (sectionNumber) {
                case 1:
                    $scope.restrictAcc.companyGroupOverview.mcaCharges = $scope.restrictAcc.companyGroupOverview.parent;
                    break;
                case 2:
                    $scope.restrictAcc.companyFinancials.summary = $scope.restrictAcc.companyFinancials.detailedAnnual = $scope.restrictAcc.companyFinancials.detailedQuarterly = $scope.restrictAcc.companyFinancials.parent;
                    break;
                case 3:
                    $scope.restrictAcc.ratings.outstandingRating = $scope.restrictAcc.ratings.instrumentRating = $scope.restrictAcc.ratings.ratingDrivers = $scope.restrictAcc.ratings.bankerDetails = $scope.restrictAcc.ratings.ratingHistory = $scope.restrictAcc.ratings.parent;
                    break;
                case 4:
                    $scope.restrictAcc.capitalMarketData.keyStockIndicator = $scope.restrictAcc.capitalMarketData.debtIssuance = $scope.restrictAcc.capitalMarketData.cpIssuance = $scope.restrictAcc.capitalMarketData.bulkAndBlock = $scope.restrictAcc.capitalMarketData.ytm = $scope.restrictAcc.capitalMarketData.parent;
                    break;
                case 6:
                    $scope.restrictAcc.crisilAnalytics.fsm = $scope.restrictAcc.crisilAnalytics.irs = $scope.restrictAcc.crisilAnalytics.companyScorecard = $scope.restrictAcc.crisilAnalytics.parent;
                    break;
                case 7:
                    $scope.restrictAcc.crisilOutlook.industryOutlook = $scope.restrictAcc.crisilOutlook.economyOutlook = $scope.restrictAcc.crisilOutlook.parent;
                    break;
                case 8:
                    $scope.restrictAcc.alternateData.epfoContribution = $scope.restrictAcc.alternateData.dueDiligence = $scope.restrictAcc.alternateData.litigations = $scope.restrictAcc.alternateData.parent;
                    break;
                default:
                    break;
            }
        }

        $scope.changeAllPoints = function() {
            $scope.restrictAcc.companyGroupOverview.parent = $scope.restrictAcc.peerBenchmarking = $scope.restrictAcc.companyFinancials.parent = $scope.restrictAcc.ratings.parent = $scope.restrictAcc.capitalMarketData.parent = $scope.restrictAcc.crisilOutlook.parent = $scope.restrictAcc.crisilAnalytics.parent = $scope.restrictAcc.alternateData.parent = $scope.section;
            $scope.changeSecondaryPoints(1);
            $scope.changeSecondaryPoints(2);
            $scope.changeSecondaryPoints(3);
            $scope.changeSecondaryPoints(4);
            $scope.changeSecondaryPoints(6);
            $scope.changeSecondaryPoints(7);
            $scope.changeSecondaryPoints(8);
        }

        $scope.setAccess = function() {
            var clientObj = JSON.parse($scope.clientModel)
            var accessObj = {
                clientId: clientObj.id,
                clientCode: clientObj.labelName,
                clientName: clientObj.name,
                companyReportRistrictDTO: $scope.restrictAcc
            }
            $scope.message = '';
            CompanyReportService.setRestrictiveAccess(accessObj).then(
				function(successData) {
					$scope.message = successData.data;
                    $scope.isError = false;
					$scope.responseMessage = successData.data;
				}, function (errorData) {
					$scope.message = errorData.data;
                    $scope.isError = false;
					$scope.responseMessage = errorData.data;
				 }
			);
        }

        $scope.getClientRestrictions = function() {
            if($scope.clientModel != 'Select Client') {
                var clientObj = JSON.parse($scope.clientModel)
                var accessObj = {
                    clientId: clientObj.id,
                    clientCode: clientObj.labelName,
                    clientName: clientObj.name
                }
                CompanyReportService.getClientRestrictions(accessObj).then(
                    function(successData) {
                        if(successData.data) {
                            $scope.restrictAcc = successData.data;
                        }
                    }, function (errorData) {
                     }
                );
            }
        }

        $scope.ifInputsInvalid = function() {
            return $scope.clientModel == 'Select Client';
        }

        $scope.closeAlert = function() {
            $scope.message = '';
        }

        $scope.getClientNameList();
    }
})();